import React from 'react';
import FamilyMemberPackageUsage from './FamilyMemberPackageUsage/FamilyMemberPackageUsage';

const FamilyMembersPackageUsages = ({ familyMembersPackageUsages }) => {
  return (
    <div className='family-members-package-usages-container'>
      {familyMembersPackageUsages.map((familyMemberPackageUsage, index) => (
        <FamilyMemberPackageUsage
          key={index}
          icon={familyMemberPackageUsage.serviceIcon}
          mobile={familyMemberPackageUsage.mobile}
          name={familyMemberPackageUsage.name}
          dataUsage={familyMemberPackageUsage.dataUsage}
        />
      ))}
    </div>
  );
};
export default FamilyMembersPackageUsages;
